// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mhG6","index":"styles_index__3IXHM"};